var path = 'src/app/patients/forms/form.html';
var html = "<h1 class=page-header>{{form.name}}</h1> <div form-component patient=patient form=form></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/forms/form.html
 ** module id = 469
 ** module chunks = 0
 **/